interface SecureBadgeProps {
  label: string;
}

/**
 * Slot marker for CheckoutProgressHeader — renders nothing itself; the root
 * reads its props and renders the lock + secure-checkout badge.
 */
const SecureBadge = (_unusedProps: SecureBadgeProps) => null;

export { SecureBadge };
export type { SecureBadgeProps };
